import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialTableSearchState } from "./initializes";
import type {} from "./types";

const tableSearchSlice = createSlice({
  name: "TableSearch",
  initialState: initialTableSearchState,
  reducers: {
    setQuery(state, action: PayloadAction<string>) {
      state.query = action.payload;
    },
    setSort(state, action: PayloadAction<string>) {
      state.sort = action.payload;
    },
    setOrder(state, action: PayloadAction<string>) {
      state.order = action.payload;
    },
    setIsFilterSearchLoading: (state, action: PayloadAction<boolean>) => {
      state.isFilterSearchLoading = action.payload;
    },
    setWildcardQuery: (state, action: PayloadAction<string>) => {
      state.wildcardQuery = action.payload;
    },
    setIsKeywordInputFocus: (state, action: PayloadAction<boolean>) => {
      state.isKeywordInputFocus = action.payload;
    },
  },
});

export const { setQuery, setSort, setOrder, setIsFilterSearchLoading, setWildcardQuery, setIsKeywordInputFocus } =
  tableSearchSlice.actions;

export default tableSearchSlice.reducer;
